import useAuth from '@State/Auth/useAuth';
import useImpersonate from '@State/Impersonate/useImpersonate';
import React from 'react';
import theme from 'src/layout/theme';
import { useRoutes } from 'src/routes/useRoutes';
import styled from 'styled-components';

interface ContainerProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

interface TermsProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  $impersonate?: boolean;
}

const ContainerBase: React.FC<ContainerProps> = ({ children, style, ...props }) => {
  const { isPrivateRoute } = useRoutes();
  const { authenticated } = useAuth();

  return !isPrivateRoute && !authenticated ? (
    <PublicContainer style={style} {...props}>
      {children}
    </PublicContainer>
  ) : (
    <PrivateContainer style={style} {...props}>
      {children}
    </PrivateContainer>
  );
};

const TermsBase: React.FC<TermsProps> = ({ children, style, ...props }) => {
  const { isPrivateRoute } = useRoutes();
  const { authenticated } = useAuth();
  const { impersonate } = useImpersonate();

  return !isPrivateRoute && !authenticated ? (
    <PublicContainer style={{ ...style, marginBottom: '64px', marginTop: '32px' }} {...props}>
      {children}
    </PublicContainer>
  ) : (
    <TermsPrivate
      $impersonate={!!impersonate}
      style={{ ...style, marginBottom: '64px' }}
      {...props}
    >
      {children}
    </TermsPrivate>
  );
};

const PrivateContainer = styled.div`
  width: 100%;
  max-width: none;
  margin: 0;

  padding: 0;
  padding-left: max(env(safe-area-inset-left), ${(props) => props.theme.size.containerGutter});

  ${(props) => props.theme.breakpoint.LtSm} {
    min-width: 100vw;
    padding: 0 ${(props) => props.theme.size.containerGutterLtSm};
    padding-left: max(
      env(safe-area-inset-left),
      ${(props) => props.theme.size.containerGutterLtSm}
    );
    padding-right: max(
      env(safe-area-inset-right),
      ${(props) => props.theme.size.containerGutterLtSm}
    );
  }
`;

const PublicContainer = styled.div`
  width: 100%;
  max-width: ${(props) => props.theme.size.containerMaxWidth};
  margin-left: auto;
  margin-right: auto;
  padding: 0 ${(props) => props.theme.size.containerGutterPublic};
  padding-left: max(
    env(safe-area-inset-left),
    ${(props) => props.theme.size.containerGutterPublic}
  );
  padding-right: max(
    env(safe-area-inset-right),
    ${(props) => props.theme.size.containerGutterPublic}
  );

  ${(props) => props.theme.breakpoint.LtSm} {
    padding: 0 ${(props) => props.theme.size.containerGutterLtSm};
    padding-left: max(
      env(safe-area-inset-left),
      ${(props) => props.theme.size.containerGutterLtSm}
    );
    padding-right: max(
      env(safe-area-inset-right),
      ${(props) => props.theme.size.containerGutterLtSm}
    );
  }
`;

const TermsPrivate = styled(PrivateContainer)<{ $impersonate: boolean }>`
  padding-top: ${({ $impersonate }) =>
    !$impersonate ? '1.5rem' : `calc(1.5rem + ${theme.size.impersonateBarHeight})`};
  overflow: auto;

  ${theme.breakpoint.LtSm} {
    padding-top: 1.5rem;
  }
`;

export const Container = styled(ContainerBase)``;
export const TermsContainer = styled(TermsBase)``;
